<template>
  <Voucher :amount="amount" :footerText="$t('common.expired')" class="expired-voucher" />
</template>

<script>
import Voucher from './Voucher.vue';

export default {
  name: 'ExpiredVoucher',
  components: {
    Voucher
  },
  props: ['amount']
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/referrals/expiredVoucher.scss';
</style>
